import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';
import { MenuItem } from 'primeng/api';
import { AvatarModule } from 'primeng/avatar';
import { MenuModule } from 'primeng/menu';
import { User } from '@monsido/ng2/modules/models/api/user';

@Component({
    selector: 'mon-profile-foldout',
    standalone: true,
    imports: [TranslocoModule, AvatarModule, MenuModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './profile-foldout.component.html',
    styleUrls: ['./profile-foldout.component.css'],
})
export class ProfileFoldoutComponent {
    constructor (private readonly translocoService: TranslocoService) {}

    @Input() user: User | null = null;
    @Input() hasCustomer: boolean = false;
    @Input() hasMultipleAccounts: boolean = false;
    @Input() hasDataExport: boolean = false;

    @Output() editProfile = new EventEmitter<void>();
    @Output() switchAccount = new EventEmitter<void>();
    @Output() myExports = new EventEmitter<void>();
    @Output() logout = new EventEmitter<void>();
    @Output() closePanel = new EventEmitter<void>();

    get menuItems (): MenuItem[] {
        return [
            ...(this.hasDataExport ? [{
                label: this.translocoService.translate('navigation.profile.foldout.myExports'),
                styleClass: 'top-nav__menu-item',
                command: () => this.onMyExports(),
            }] : []),
            ...(this.hasMultipleAccounts ? [{
                label: this.translocoService.translate('navigation.profile.foldout.switchAccount'),
                styleClass: 'top-nav__menu-item',
                command: () => this.onSwitchAccount(),
            }] : []),
            ...(this.hasCustomer ? [{
                label: this.translocoService.translate('navigation.profile.foldout.editProfile'),
                styleClass: 'top-nav__menu-item',
                command: () => this.onEditProfile(),
            }] : []),
            {
                label: this.translocoService.translate('navigation.profile.foldout.logout'),
                styleClass: 'top-nav__menu-item',
                command: () => this.onLogout(),
            },
        ];
    }

    getAvatarInitials (): string {
        if (!this.user) {
            return '';
        }
        return this.user.getAvatarInitials();
    }

    getFullName (): string {
        if (!this.user) {
            return '';
        }
        const parts: string[] = [];
        if (this.user.first_name) {
            parts.push(this.user.first_name);
        }
        if (this.user.last_name) {
            parts.push(this.user.last_name);
        }
        return parts.join(' ');
    }

    getOrganization (): string {
        if (!this.user?.customer) {
            return '';
        }
        return this.user.customer?.name ?? '';
    }

    onMyExports (): void {
        this.myExports.emit();
        this.closePanel.emit();
    }

    onSwitchAccount (): void {
        this.switchAccount.emit();
        this.closePanel.emit();
    }

    onEditProfile (): void {
        this.editProfile.emit();
        this.closePanel.emit();
    }

    onLogout (): void {
        this.logout.emit();
    }
}
